import gigya from './rbata.gigya';

const gigyaRegisterLogin = {

    // screen ids
    CDC_LOGIN_PAGE_SCREEN:              'cdc-loginPageLogin',
    CDC_FORGOTTEN_PASS_SCREEN:          'cdc-gigya-forgotten-pass-container',
    CDC_FORGOT_PASSWORD_SUCCESS_SCREEN: 'gigya-forgot-password-success-screen',
    CDC_REGISTRATION_SCREEN:            'gigya-register-screen',
    CDC_NL_EMAIL_FIELD:                 'subscriptions.newsletter.email.isSubscribed',

    registrationLoginAfterScreenload: (evt) => {
        let data = evt.detail;

        gigya.showPasswordCheckbox();

        // success view after forgotten password form
        if (data.currentScreen === gigyaRegisterLogin.CDC_FORGOT_PASSWORD_SUCCESS_SCREEN) {
            $('#js-forgotten-pw-page__description').hide();
            gigya.removeGlobalMessages();
        }

        const $form_container = $('#gigya-register-screen .gigya-register-form');

        /**
         * Delegate click on label to radio button
         */
        if (data.currentScreen === gigyaRegisterLogin.CDC_REGISTRATION_SCREEN) {
            const $nl_choice = $form_container.find('.registration-nl__choice');

            // Set correct legal text
            const selectedOption = $nl_choice.find('.gigya-input-radio:checked');

            if (selectedOption) {
                gigyaRegisterLogin.adjustLegalText($form_container, selectedOption.val() === 'true');
            }

            $nl_choice.on('click', 'label', function (evt) {
                let $this = $(evt.target);
                $this.siblings('input[type="radio"]').click();
            });
            
            /**
             * Wrap elements to create suitable structure for scss
             */
            $form_container.find('.wrap-element').wrapAll('<div class="registration-nl__additional d-none">');
            $form_container.find('.wrap-element-date').wrapAll('<div class="registration-nl__date-fields">');
            $form_container.find('.wrap-element-date:not(:last-child)').after('<span class="date-delimiter"></span>');

            /**
             * Prefill newsletter language based on current shop language
             */
            let $languageField = $form_container.find('[name="data.nl.language"]')
            $languageField.find('option[value="' + alphatauri.config.language + '"]') ?
                    $languageField.val(alphatauri.config.language) :
                    $languageField.val('en');

        }
    },

    registrationLoginError: (evt) => {
        let data = evt.detail;

        // RBATA login page (account and checkout)
        if (data.sourceContainerID === gigyaRegisterLogin.CDC_LOGIN_PAGE_SCREEN
                || data.sourceContainerID === gigyaRegisterLogin.CDC_FORGOTTEN_PASS_SCREEN) {
            gigya.renderGlobalMessages(data.response.errorMessage);
        }
    },

    adjustLegalText: (wrapper, optionValue) => {
        const legalTextYes = wrapper.find('.registration-nl__text-yes');
        const legalTextNo  = wrapper.find('.registration-nl__text-no');

        if (optionValue) {
            legalTextYes.removeClass('d-none');
            legalTextNo.addClass('d-none');
        } else {
            legalTextYes.addClass('d-none');
            legalTextNo.removeClass('d-none');
        }
    },

    registrationLoginAfterFieldChange: (evt) => {
        let data = evt.detail;

        // be aware there are always two inputfields with the same name in the DOM (one is hided by CDC)
        const $targetInput           = $('.gigya-screen-content [name="' + data.field + '"]');
        const $gigyaCompositeControl = $targetInput.closest('.gigya-composite-control');
        const $form                  = $targetInput.closest('form');

        function showAdditionalNewlsetterFields(state) {
            const $nl_group = $('.registration-nl__additional');
            state ? $nl_group.removeClass('d-none') : $nl_group.addClass('d-none');
        }

        if (data.isValid) {
            $gigyaCompositeControl.removeClass('gigya-composite-control--error');
        } else {
            $gigyaCompositeControl.addClass('gigya-composite-control--error');
        }

        // Check if newlsetter radiobutton value changed
        if (data.field === gigyaRegisterLogin.CDC_NL_EMAIL_FIELD) {
            gigyaRegisterLogin.adjustLegalText($form, data.value === 'true');
            showAdditionalNewlsetterFields(data.value === 'true');
        }
    },

    registrationSubmit: (event) => {
        gigya.clearUncheckedSubscriptions(event);
        gigya.setAdditionalGeoDetails(event);
    },

    bindHandler: () => {
        // Called after a new screen is rendered.
        document.addEventListener('gigya-registration-login-after-screenload', gigyaRegisterLogin.registrationLoginAfterScreenload);
        // Called when an error occurs.
        document.addEventListener('gigya-registration-login-error', gigyaRegisterLogin.registrationLoginError);
        // Called when a field is changed in a managed form.
        document.addEventListener('gigya-registration-login-field-change', gigyaRegisterLogin.registrationLoginAfterFieldChange);
        // Called when form is finally submitted.
        document.addEventListener('gigya-registration-on-submit', gigyaRegisterLogin.registrationSubmit);
    }
}

export default gigyaRegisterLogin;
